import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Close20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.0001 8.93934L3.53039 2.46967L2.46973 3.53033L8.9394 10L2.46973 16.4697L3.53039 17.5303L10.0001 11.0607L16.4697 17.5303L17.5304 16.4697L11.0607 10L17.5304 3.53033L16.4697 2.46968L10.0001 8.93934Z'
      fill='currentColor'
    />
  </Svg>
);

Close20.displayName = 'Close20';
export default Close20;
